(function(){
  var DEADLINE = new Date('2026-10-31T23:59:59+02:00').getTime();
  if(Date.now() > DEADLINE) return;

  function patchFdcData(){
    var el = document.querySelector('[data-fdc-data]');
    if(!el) return;
    try {
      var d = JSON.parse(el.textContent);
      if(d.fin) d.fin.forEach(function(f){
        if(f.k==='matte'||f.k==='glitter'){ f.p=0; f.id=''; }
      });
      el.textContent = JSON.stringify(d);
    } catch(e){}
  }

  function styleCards(){
    document.querySelectorAll('.fdc__card').forEach(function(card){
      var nameEl = card.querySelector('.fdc__card-name');
      if(!nameEl) return;
      var n = nameEl.textContent.trim();
      if(n!=='Mate' && !n.toLowerCase().includes('pailleté') && n!=='Matte' && n!=='Glitter') return;
      var pr = card.querySelector('.fdc__card-price');
      if(pr && !card.querySelector('.hween-badge')){
        pr.textContent='OFFERT 🎃';
        pr.style.cssText='background:#e65c00;color:#fff;border-radius:4px;padding:2px 8px;font-weight:700;font-size:11px;';
      }
      var tag = card.querySelector('.fdc__tag');
      if(tag) tag.remove();
      if(!card.querySelector('.hween-badge')){
        card.style.position='relative';
        var b=document.createElement('span');
        b.className='hween-badge';
        b.style.cssText='position:absolute;top:0;right:0;background:#e65c00;color:#fff;font-size:9px;font-weight:800;padding:3px 8px;border-bottom-left-radius:6px;z-index:3;line-height:1.4;pointer-events:none;';
        b.textContent='🎃 HALLOWEEN';
        card.insertBefore(b,card.firstChild);
      }
    });
    document.querySelectorAll('[class*="-card"]').forEach(function(card){
      if(card.classList.contains('fdc__card')) return;
      var t=card.querySelector('[class*="-card-title"]');
      if(!t) return;
      var title=t.textContent.trim();
      if(title!=='Mate'&&title!=='Pailleté') return;
      var p=card.querySelector('[class*="-card-price"]');
      if(p&&!card.querySelector('.hween-badge')){
        p.textContent='OFFERT 🎃'; p.style.background='#e65c00'; p.style.color='#fff';
      }
      var oc=card.getAttribute('onclick');
      if(oc&&oc.indexOf("'fin'")!==-1){
        card.setAttribute('onclick',oc.replace(/'fin'\s*,\s*\d+\s*,/,"'fin',0,"));
      }
      if(!card.querySelector('.hween-badge')){
        var b=document.createElement('span');
        b.className='hween-badge';
        b.style.cssText='position:absolute;top:0;right:0;background:#e65c00;color:#fff;font-size:9px;font-weight:800;padding:3px 8px;border-bottom-left-radius:6px;z-index:3;line-height:1.4;';
        b.textContent='🎃 HALLOWEEN';
        card.insertBefore(b,card.firstChild);
      }
    });
  }

  function addMystery(){
    document.querySelectorAll('.fdc__ups').forEach(function(ups){
      if(ups.querySelector('.hween-mystery')) return;
      var el=document.createElement('div');
      el.className='hween-mystery';
      el.style.cssText='display:flex;align-items:center;padding:15px;border:2px dashed #e65c00;border-radius:8px;margin-bottom:15px;background:#fff8f4;';
      el.innerHTML='<div style="font-size:36px;margin-right:15px;flex-shrink:0;">🎃</div><div><div style="font-weight:800;text-transform:uppercase;font-size:13px;">Cadeau mystère offert !</div><div style="font-size:12px;color:#e65c00;margin-top:4px;">Une surprise Halloween incluse dans votre commande 🎁</div></div>';
      ups.insertBefore(el,ups.firstChild);
    });
    var seen=[];
    document.querySelectorAll('[class*="-upsell-row"]').forEach(function(row){
      var p=row.parentElement;
      if(seen.indexOf(p)!==-1) return; seen.push(p);
      if(p.querySelector('.hween-mystery')) return;
      var el=document.createElement('div');
      el.className='hween-mystery';
      el.style.cssText='display:flex;align-items:center;padding:15px;border:2px dashed #e65c00;border-radius:8px;margin-bottom:15px;background:#fff8f4;';
      el.innerHTML='<div style="font-size:36px;margin-right:15px;flex-shrink:0;">🎃</div><div><div style="font-weight:800;text-transform:uppercase;font-size:13px;">Cadeau mystère offert !</div><div style="font-size:12px;color:#e65c00;margin-top:4px;">Une surprise Halloween incluse dans votre commande 🎁</div></div>';
      p.insertBefore(el,p.querySelector('[class*="-upsell-row"]'));
    });
  }

  function applyAll(){ styleCards(); addMystery(); }
  var mo = new MutationObserver(applyAll);
  patchFdcData();
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){ applyAll(); mo.observe(document.body,{childList:true,subtree:true}); });
  } else {
    applyAll(); mo.observe(document.body,{childList:true,subtree:true});
  }
})();